import React, {useEffect, useState} from "react";
import axios from "config/axiosConfig";
import {Link, useSearchParams, useNavigate, useLocation} from "react-router-dom";
import {Pagination} from "page/util/Pagination";
import {formatBusinessNumber, formatDate, formatPhoneNumber} from "page/util/helpers";
import DatePicker from "react-datepicker";

export default function Main() {
    const [searchParams, setSearchParams] = useSearchParams();
    const [history, setHistory] = useState({});
    const [paginationDto, setPaginationDto] = useState();
    const [users, setUsers] = useState([]);

    const navigate = useNavigate();
    const location = useLocation();

    const queryParams = new URLSearchParams(location.search); // 쿼리 파라미터 추출
    const id = queryParams.get("id");
    const page = searchParams.get('page') || "1";

    const requestGetHistory = (e) => {
        axios.get(`/admin/push/messages/send-histories/${id}`)
            .then((res) => {
                setHistory(res.data);
            });
    }

    const requestGetUsers = (e) => {
        const params = {};
        params.page = page;
        params.pageSize = 3;

        axios.get(`/admin/push/messages/send-histories/${id}/users`, {params: params})
            .then((res) => {
                setPaginationDto(res.data);
                setUsers(res.data.content);
            });
    }

    const displayMessageType = (messageType) => {
        switch (messageType) {
            case "INFORMATION": return "정보성";
            case "MARKETING": return "광고성";
            default: return "";
        }
    }

    const displaySendType = (sendType) => {
        switch (sendType) {
            case "IMMEDIATE": return "즉시 발송";
            case "SCHEDULED": return "예약 발송";
            case "RECURRING": return "반복 발송";
            default: return "";
        }
    }

    const displayMembershipType = (membershipType) => {
        switch (membershipType) {
            case "BASIC": return "BASIC";
            case "BUSINESS": return "BUSINESS";
            default: return "전체";
        }
    }

    const setPage = (page) => {
        searchParams.set('page', page);
        setSearchParams(searchParams, {replace: true});
    }

    useEffect(() => {
        requestGetHistory();
    }, []);

    useEffect(() => {
        requestGetUsers();
    }, [page]);

    return (
        <div className="App">
            <div className="wrapper">
                <div className="content-wrapper" style={{marginLeft: '0px'}}>
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-12">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item active">푸시메시지 - 발송이력</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">

                                    <div className="invoice p-3 mb-3">
                                        <div className="row">
                                            <div className="col-12">
                                                <p className="lead">발송이력</p>
                                                <div className="table-responsive">
                                                    <table className="table">
                                                        {
                                                            history && (
                                                                <tbody>
                                                                <tr>
                                                                    <th style={{width: "120px"}}>이력ID</th>
                                                                    <td>{history.id}</td>
                                                                    <th style={{width: "120px"}}>발송 회원수</th>
                                                                    <td>{history.userCount}</td>
                                                                </tr>
                                                                <tr>
                                                                    <th>메시지 종류</th>
                                                                    <td>{displayMessageType(history.messageType)}</td>
                                                                    <th style={{width: "120px"}}>전송방식</th>
                                                                    <td>{displaySendType(history.sendType)}</td>
                                                                </tr>
                                                                <tr>
                                                                    <th>발송일</th>
                                                                    <td>{formatDate(history.createdAt)}</td>
                                                                    <th>대상</th>
                                                                    <td>{displayMembershipType(history.membershipType)}</td>
                                                                </tr>
                                                                <tr>
                                                                    <th style={{width: "120px"}}>제목</th>
                                                                    <td colSpan={3}>{history.title}</td>
                                                                </tr>
                                                                <tr>
                                                                    <th style={{width: "120px"}}>내용</th>
                                                                    <td colSpan={4}>
                                                                        <textarea rows="4" disabled style={{width: '100%'}} readOnly={true} value={history.content}>
                                                                        </textarea>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <th style={{width: "120px"}}>링크</th>
                                                                    <td colSpan={3}>{history.link}</td>
                                                                </tr>
                                                                </tbody>
                                                            )
                                                        }
                                                    </table>
                                                </div>
                                            </div>
                                            {/* /.col */}
                                        </div>
                                    </div>

                                    <div className="row" style={{marginTop: '30px', marginBottom: '10px'}}>
                                        <div style={{margin: "0 auto"}}>
                                            <button type="button" className="btn btn-outline-dark"
                                                    onClick={e => navigate(-1)}>
                                                목록
                                            </button>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="content" style={{marginTop: '50px'}}>
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-tools" style={{marginTop: '40px', marginLeft: '20px'}}>
                                            <p className="lead">발송 회원</p>
                                        </div>
                                        <div className="card-body table-responsive p-0" style={{marginTop: '0px'}}>
                                            <table className="table table-hover text-nowrap"
                                                   style={{textAlign: "center"}}>
                                                <thead>
                                                <tr>
                                                    <th>회원ID</th>
                                                    <th>이메일</th>
                                                    <th>이름</th>
                                                    <th>보기</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {
                                                    users && users.map(item => {
                                                        return (
                                                            <tr key={item.userId}>
                                                                <td>{item.userId}</td>
                                                                <td>{item.userEmail}</td>
                                                                <td>{item.userName}</td>
                                                                <td>
                                                                    <Link to={`/page/user/member/detail?userId=${item.userId}`} target="_blank">
                                                                        <button type="button"
                                                                                className="btn btn-outline-primary btn-sm">
                                                                            보기
                                                                        </button>
                                                                    </Link>
                                                                </td>
                                                            </tr>
                                                        )
                                                    })
                                                }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        { paginationDto && <Pagination pager={paginationDto} setPage={setPage}/> }
                    </section>

                </div>
            </div>
        </div>
    );
}


